/**
 * Created by 胡长伟 on 2021-01-21.
 */
import {Utils} from '../../app.base';

let fileType2fileExts = {
    // Text("文本文件")
    'txt': '.txt',
    'xml': '.xml',
    'json': '.json',
    'html': ['.html', '.htm', '.xhtml'],
    'css': '.css',
    'js': '.js',
    // Office("办公文档")
    'doc': ['.doc', '.docx', '.rtf', '.odt'],
    'xls': ['.xls', '.xlsx', '.csv', '.ods'],
    'ppt': ['.ppt', '.pptx', '.odp'],
    'pdf': '.pdf',
    // Image("图片")
    'jpg': ['.jpg', '.jpeg'],
    'png': '.png',
    'gif': '.gif',
    'bmp': '.bmp',
    'ico': '.ico',
    'svg': '.svg',
    'webp': '.webp',
    // Audio("音频", 3)
    // TODO

    // Video("视频")
    // TODO

    // Font("字体")
    'eot': '.eot',
    'otf': '.otf',
    'ttf': '.ttf',
    'woff': ['.woff', '.woff2'],
    // Zipped("压缩")
    'zip': '.zip',
    'rar': '.rar',
    'gzip': '.gz',
    'tar': '.tar',
    'zip7': '.7z'
};

let fileExt2fileTypes = {};
{
    for (let fileType in fileType2fileExts) {
        let fileExts = fileType2fileExts[fileType];
        if (typeof fileExts == 'string') {
            fileExts = [fileExts];
        }
        for (let i = 0, c = fileExts.length; i < c; i++) {
            fileExt2fileTypes[fileExts[i]] = fileType;
        }
    }
}

/** 判断文件类型名称 */
export function judgeFileType(fileName, fileUrl) {
    let fileExt = Utils.extractFileNameExt(fileName);
    if (!fileExt) {
        fileExt = Utils.extractFileNameExt(fileUrl);
    }
    if (fileExt) {
        return fileExt2fileTypes[fileExt.toLowerCase()] || null;
    }
    return null;
}

//获取java类型的简单名称（去掉前面包名）
function toJavaSimpleTypeName(javaTypeName, toLower) {
    if (javaTypeName == null) {
        return null;
    }
    if (javaTypeName.startsWith('[L') && javaTypeName.endsWith(';')) {
        //形如：[Ljava.lang.String; 当列表对待
        javaTypeName = javaTypeName.substring(2, javaTypeName.length - 1) + '[]';
    }
    let dotIndex = javaTypeName.lastIndexOf('.');
    let retName = dotIndex == -1 ? javaTypeName : javaTypeName.substring(dotIndex + 1);
    return toLower == true ? retName.toLowerCase() : retName;
}

// java类型名称 => 普通类型名称
// string, integer, float, boolean, date, map
const supportedSimpleShortTypeNames = ['string', 'integer', 'float', 'boolean', 'date'];

const supportedJavaShortTypeNames = supportedSimpleShortTypeNames.concat('map');

const javaShortTypeNameMap = {
    // => string
    'char': 'string',
    'Character': 'string',
    'str': 'string',
    // => integer
    'int': 'integer',
    'long': 'integer',
    'short': 'integer',
    'byte': 'integer',
    // => float
    'double': 'float',
    'bigdecimal': 'float',
    //=> boolean
    'bool': 'boolean',
    // => map
    'hashmap': 'map'
};
//普通类型兼容性Map
const javaShortTypeNameCompatMap = {
    'integer': 'float',
};

// 转为java普通类型名称
export function toJavaShortTypeName(javaTypeName) {
    let simpleName = toJavaSimpleTypeName(javaTypeName, true);
    if (simpleName == null) {
        return null;
    }
    let listFlagIndex = simpleName.lastIndexOf('[');
    let listFlag = listFlagIndex > 0;
    if (listFlag) {//列表类型
        simpleName = simpleName.substring(0, listFlagIndex).trim();
        return (javaShortTypeNameMap[simpleName] || simpleName) + '[]';
    } else {
        return javaShortTypeNameMap[simpleName] || simpleName;
    }
}

//判断给定的类型是否与定义的类型兼容
export function javaShortTypeCompatible(givenType, defineType) {
    return givenType == defineType || defineType == 'string' || javaShortTypeNameCompatMap[givenType] == defineType;
}

//是否为支持的简单类型
export function isSupportedJavaSimpleType(typeName) {
    let shortName = toJavaShortTypeName(typeName);
    return supportedSimpleShortTypeNames.indexOf(shortName) != -1;
}

const dateExprFuncs = {
    getDate(delta) {//today
        let ret = new Date();
        if (Utils.isInt(delta)) {
            ret = ret.addDays(delta);
        }
        return ret;
    },
    //
    getMonthFirstDay(delta) {//month.firstday
        let ret = new Date();
        if (Utils.isInt(delta)) {
            ret = ret.addMonths(delta);
        }
        let theDay = 1;
        ret = new Date(ret.getFullYear(), ret.getMonth(), theDay);
        return ret;
    },
    getMonthLastDay(delta) {//month.lastday
        let ret = new Date();
        if (Utils.isInt(delta)) {
            ret = ret.addMonths(delta);
        }
        let theDay = ret.getMonthDays();
        ret = new Date(ret.getFullYear(), ret.getMonth(), theDay);
        return ret;
    },
    //
    getYearFirstDay(delta) {//year.firstday
        let ret = new Date();
        if (Utils.isInt(delta)) {
            ret = ret.addYears(delta);
        }
        ret = new Date(ret.getFullYear(), 0, 1);
        return ret;
    },
    getYearLastDay(delta) {//year.lastday
        let ret = new Date();
        if (Utils.isInt(delta)) {
            ret = ret.addYears(delta);
        }
        ret = new Date(ret.getFullYear(), 11, 31);
        return ret;
    }
};

//处理默认日期表达式
export function evalDateExpr(dateExpr) {
    dateExpr = dateExpr || '';
    dateExpr = dateExpr.trim();
    switch (dateExpr) {
        case 'today' :
            return dateExprFuncs.getDate();
            break;
        case 'today-1' :
            return dateExprFuncs.getDate(-1);
            break;
        //
        case 'month.firstday' :
            return dateExprFuncs.getMonthFirstDay();
            break;
        case 'month.lastday' :
            return dateExprFuncs.getMonthLastDay();
            break;
        case 'month-1.firstday' :
            return dateExprFuncs.getMonthFirstDay(-1);
            break;
        case 'month-1.lastday' :
            return dateExprFuncs.getMonthLastDay(-1);
            break;
        //
        case 'year.firstday' :
            return dateExprFuncs.getYearFirstDay();
            break;
        case 'year.lastday' :
            return dateExprFuncs.getYearLastDay();
            break;
        case 'year-1.firstday' :
            return dateExprFuncs.getYearFirstDay(-1);
            break;
        case 'year-1.lastday' :
            return dateExprFuncs.getYearLastDay(-1);
            break;

        //
        default :
            return null;
            break;
    }
};

/*
console.log(evalDateExpr('today').format('yyyy-MM-dd'));
console.log(evalDateExpr('today-1').format('yyyy-MM-dd'));

console.log(evalDateExpr('month.firstday').format('yyyy-MM-dd') + ' ~ ' + evalDateExpr('month.lastday').format('yyyy-MM-dd'));
console.log(evalDateExpr('month-1.firstday').format('yyyy-MM-dd') + ' ~ ' + evalDateExpr('month-1.lastday').format('yyyy-MM-dd'));

console.log(evalDateExpr('year.firstday').format('yyyy-MM-dd') + ' ~ ' + evalDateExpr('year.lastday').format('yyyy-MM-dd'));
console.log(evalDateExpr('year-1.firstday').format('yyyy-MM-dd') + ' ~ ' + evalDateExpr('year-1.lastday').format('yyyy-MM-dd'));
*/

//
function encodeAsInt8Array(str) {
    str = str || '';
    var bytes = [];
    for (var i = 0, c = str.length; i < c; i++) {
        var chr = str.charCodeAt(i);
        if (chr >= 0x010000 && chr <= 0x10FFFF) {
            bytes.push(((chr >> 18) & 0x07) | 0xF0);
            bytes.push(((chr >> 12) & 0x3F) | 0x80);
            bytes.push(((chr >> 6) & 0x3F) | 0x80);
            bytes.push((chr & 0x3F) | 0x80);
        } else if (chr >= 0x000800 && chr <= 0x00FFFF) {
            bytes.push(((chr >> 12) & 0x0F) | 0xE0);
            bytes.push(((chr >> 6) & 0x3F) | 0x80);
            bytes.push((chr & 0x3F) | 0x80);
        } else if (chr >= 0x000080 && chr <= 0x0007FF) {
            bytes.push(((chr >> 6) & 0x1F) | 0xC0);
            bytes.push((chr & 0x3F) | 0x80);
        } else {
            bytes.push(chr & 0xFF);
        }
    }
    var array = new Int8Array(bytes.length);
    for (let i = 0, c = bytes.length; i < c; i++) {
        array[i] = bytes[i];
    }
    return array;
}

export function downloadTextFile(content, mimeType, fileName) {
    mimeType = mimeType || 'text/plain; charset=utf-8';
    fileName = fileName || '未命名.txt';
    const data = encodeAsInt8Array(content || '');

    const blob = new Blob([data], {
        type: mimeType
    });

    if (window.navigator && window.navigator.msSaveBlob) { //IE
        window.navigator.msSaveBlob(blob, fileName);
    } else { //非IE
        let tmpLink = document.createElement('A');
        document.body.appendChild(tmpLink);
        tmpLink.style = 'display: none';
        let fileUrl = window.URL.createObjectURL(blob);
        tmpLink.href = fileUrl;
        tmpLink.download = fileName;
        tmpLink.click();
        window.URL.revokeObjectURL(tmpLink.href);
        document.body.removeChild(tmpLink);
        tmpLink.remove();
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/ctrl/Cmn.js
// module id = 209
// module chunks = 0